import { TranslatePipe } from '../../filters/translate.pipe';
import { ElementRef, Input, Output, EventEmitter, NgZone } from '@angular/core';
import { Component, OnInit, inject, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import Session from '../../utils/session.service';
import Config from '../../utils/config.service';
import AngularHelperService from '../../services/angular-helper.service';
import AngularFilterHelperService from '../../services/angular-filter-helper.service';
import $ from 'jquery';
import moment from 'moment';
import 'daterangepicker';

@Component({
	standalone: true,
	selector: 'input-datepicker-new',
	templateUrl: './input-datepicker-new.component.html',
	imports: [ CommonModule, TranslatePipe, FormsModule ]
})
export class InputDatepickerNewComponent implements OnInit, OnDestroy {
	private session: Session = inject(Session);
	private config: Config = inject(Config);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private zone: NgZone = inject(NgZone);
	
	@Input() isRequired: any | undefined;
	@Input() minDate: any | undefined;
	@Input() hasDropdowns: any | undefined;
	@Input() isSmall: any | undefined;
	@Input() hasMinWidth: any | undefined;
	@Input() hasTimepicker: any | undefined;
	@Input() isFixedPosition: any | undefined;
	@Input() name: any | undefined;
	@Input() hasCalendarIcon: any | undefined;
	@Input() isSingleDate: any | undefined;
	@Input() opens: any | undefined;
	@Input() drops: any | undefined;
	@Input() model: any;
	@Output() modelChange: EventEmitter<any> = new EventEmitter<any>();
	@Input() parentEl: any | undefined;
	@Input() isAutoApplying: any | undefined;
	@Input() id: any | undefined;
	@Input() placeholder: any | undefined;
	@Input() startDate: any | undefined;
	@Input() isClearable: any | undefined;
	
	vm: any = undefined;
	watcher: any = undefined;
	
	constructor(private elementRef: ElementRef) {
		this.vm = this;
	}
	
	ngOnInit() {
		this.vm.iconTopOffset = this.vm.isSmall ? '10px' : '44px';
		this.vm.width = this.vm.hasMinWidth ? '80%' : '100%';
		this.handleDatepickerInit();
		this.vm.handleInputReset = this.handleInputReset;
		this.vm.handleCalendarIconClick = this.handleCalendarIconClick;
	}
	
	ngOnDestroy() {
		if (this.vm.datepicker) this.vm.datepicker.remove();
		if (this.watcher) {
			this.angularHelperService.cancelInterval(this.watcher);
		}
	}
	
	handleDatepickerInit() {
		var user: any = this.session.getSession().user;
		var language: any = (user.deviceLanguage || this.config.getSettings().DEFAULT_LANG).slice(0, 2);
		
		this.vm.datepickerInputElement = this.angularHelperService.element(this.elementRef.nativeElement)[0].querySelector('input');
		if (!this.vm.datepickerInputElement) return;
		this.vm.datepickerFormat = this.vm.hasTimepicker ? 'DD.MM.YYYY H:mm' : 'DD.MM.YYYY';
		
		this.handleInputReset();
		this.resetDateRangePicker(language);
		this.vm.datepicker.container.addClass('c-datepicker');
		
		$(this.vm.datepickerInputElement).on('hide.daterangepicker', (ev, picker) => {
			this.zone.run(() => {
				if (!this.vm.model) {
					this.vm.model = moment(new Date()).format();
					this.modelChange.emit(this.vm.model);

					// Dispatch input event for Angular forms
					const event = new Event('input', { bubbles: true });
					this.vm.datepickerInputElement.dispatchEvent(event);
				}
			});
		});
		
		var currentModel = this.vm.model;
		var currentMinDate = this.vm.minDate;
		this.watcher = this.angularHelperService.createInterval(() => {
			var newModel = this.vm.model;
			if (!this.angularHelperService.isEqual(currentModel, newModel)) {
				if (newModel && newModel.start) {
					currentModel = Object.assign({}, newModel);
				} else {
					currentModel = newModel;
				}
			}
			
			if (this.vm.minDate !== currentMinDate) {
				currentMinDate = this.vm.minDate;
				if (currentMinDate) {
					this.resetDateRangePicker(language);
				}
			}
		}, 300);
	}
	
	handleInputReset() {
		if (this.vm.isSingleDate) {
			if (this.vm.model) {
				this.vm.inputModel = moment(this.vm.model).format(this.vm.datepickerFormat)
			} else {
				this.vm.inputModel = this.vm.startDate
					? moment(this.vm.startDate).format(this.vm.datepickerFormat)
					: undefined;
			}
		} else {
			this.vm.inputModel = moment(this.vm.model.start).format(this.vm.datepickerFormat)
				+ ' - ' + moment(this.vm.model.end).format(this.vm.datepickerFormat);
		}
	}
	
	handleCalendarIconClick($event) {
		if (this.vm.hasCalendarIcon && this.vm.datepicker) {
			this.vm.datepicker.show();
		}
	}
	
	resetDateRangePicker(language) {
		var pickerEl: any = $(this.vm.datepickerInputElement);
		var momentRef: any = moment.localeData(language);
		this.vm.datepicker = pickerEl.daterangepicker({
			applyButtonClasses: 'c-button--s1 u-osl-xs',
			autoApply: this.vm.isAutoApplying,
			autoUpdateInput: this.vm.isAutoApplying,
			buttonClasses: 'c-button c-button--narrow',
			cancelButtonClasses: 'c-button--s6',
			linkedCalendars: false,
			locale: {
				firstDay: 1,
				daysOfWeek: momentRef._weekdaysShort,
				monthNames: momentRef._monthsShort,
				format: this.vm.datepickerFormat,
				applyLabel: this.angularFilterHelperService.translate('Modal.Button.Select'),
				cancelLabel: this.angularFilterHelperService.translate('Common.Cancel')
			},
			minDate: this.vm.minDate ? moment(this.vm.minDate) : moment(),
			opens: this.vm.opens || 'left',
			drops: this.vm.drops || 'down',
			parentEl: this.vm.parentEl || 'body',
			singleDatePicker: this.vm.isSingleDate,
			showDropdowns: this.vm.hasDropdowns,
			startDate: this.vm.isSingleDate ? (this.vm.startDate ? moment(this.vm.startDate) : moment()) : moment(this.vm.model.start),
			endDate: !this.vm.isSingleDate ? moment(this.vm.model.end) : moment(),
			timePicker: this.vm.hasTimepicker,
			timePicker24Hour: true,
			timePickerSeconds: false
		}, (start, end) => {
			this.zone.run(() => {
				if (this.vm.isSingleDate) {
					this.vm.model = moment(start).format();
					this.handleInputReset();
				} else {
					this.vm.model = {
						start: moment(start).format(),
						end: moment(end).format()
					};
					this.handleInputReset();
				}
				this.modelChange.emit(this.vm.model);
			});
		}).data('daterangepicker');
		
		pickerEl.on('apply.daterangepicker', (ev, picker) => {
			this.zone.run(() => {
				if (this.vm.isSingleDate) {
					this.vm.model = moment(picker.startDate).format();
				} else {
					this.vm.model = {
						start: moment(picker.startDate).format(),
						end: moment(picker.endDate).format()
					};
				}
				this.handleInputReset();
				this.modelChange.emit(this.vm.model);

				// Also dispatch input event for Angular forms
				const event = new Event('input', { bubbles: true });
				this.vm.datepickerInputElement.dispatchEvent(event);
			});
		});
		
		if (this.vm.isFixedPosition) {
			$('.daterangepicker').addClass('c-datepicker-fixed');
		}
		$(document).on('keypress', function(e) {
		    if (e.which === 13 && pickerEl.is(':visible')) {
		        let picker = pickerEl.data('daterangepicker');
		        
		        picker.hide();
		        picker.callback(picker.startDate, picker.endDate);
		    }
		});
	}
	
}
